export enum AppConsts {
  AccessToken = 'access_token',
  CurrencyPlaceholder = '{{ currency }}',
  FullNamePlaceholder = '{{ fullName }}'
}
